(function (window, $) {

    init();

    function init() {
        $('body').on('change', '.select-multiple__input', optionsChanged);

        $('.select-multiple__option:first-child').each(function (index, elem) {
            $(elem).find('.select-multiple__input').trigger('change');
        });
    }

    function optionsChanged(event) {
        var input = $(this);
        var wrapper = input.closest('.select-multiple-wrapper');

        if (!wrapper.length) {
            return;
        }

        var headerOptions = wrapper.find('.select-multiple-header__options');

        if (!headerOptions.length) {
            return;
        }

        var selected = [];

        wrapper.find('.select-multiple__input:checked').each(function (index, elem) {
            elem = $(elem);
            var label = $(elem).closest('.select-multiple__option').find('.select-multiple__label');

            if (label.length) {
                selected.push(label.text().trim());
            }
        });

        if (!headerOptions.data('originalText')) {
            headerOptions.data('originalText', headerOptions.text());
        }

        if (selected.length) {
            headerOptions.text(selected.join(', '));
        } else {
            headerOptions.text(headerOptions.data('originalText'));
        }
    }

})(window, jQuery);
